// extracted by mini-css-extract-plugin
module.exports = {"root":"Employees_root__2OqK1"};